module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAMAAADypuvZAAAAeFBMVEUAAABAQEBAQEBAQEBAQFJCQlJAQFBAQE5ERFCbn6xERFFDQ1CcnqxFRVBFRVBERFGbnqxERlJERlFERlFERlBDRVJFRVKcn6ydn61FRVFERlKdnqxERVJERVFFRVFFRlJFRVJFRlFERVFERVJERVGdn61FRlKdn618Ab1kAAAAJnRSTlMABAgMHB8gJEBKT1BfYHN0e4OHi4+fn5+fo7vFy8/P19vf7/P7/p2glAQAAACjSURBVEjH7ZbJDoIwGAbBBRfccEFxr+D4/m/oRSUtv+3FRGs6xy+ZQ5uUIYoCXtFeHioe1Otz4Vx0m05PUSNIUA5NJ97jkrh0DCnFLTE3pAzIW+9PHE+BrTHmwNh2TwmgguSl9AUGIwmHtLsJXH9Gmm0E1l5+9cLT+GMpA1a2AEyEAOip6b92ZUuNHjVZakRNz6colakQ6sWxskinIgk/M5/hDthFQahT6CsSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/scan-black.png
// module id = 4QQK
// module chunks = 1